import React from 'react';
import PropTypes from 'prop-types';

const PopupDoneBox = props => (
  <button
    className={`popup-done-box ${props.isEditable ? '' : 'uneditable'}`}
    onClick={props.onClick}
    style={props.style}
  >
    <span>
      {props.label}
      {props.superScript}
    </span>
  </button>
);

PopupDoneBox.defaultProps = {
  isEditable: true,
  label: '',
  superScript: null,
  style: {},
};

PopupDoneBox.propTypes = {
  isEditable: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  superScript: PropTypes.node,
  style: PropTypes.shape({}),
};

export default PopupDoneBox;



// WEBPACK FOOTER //
// ./src-react/Popups/SelfServeBuilderPopups/PopupDoneBox.jsx